import React from 'react';
import styled from 'styled-components';
import { Link } from '../Common';
import { colors, preHeaderHeight } from '../variables';

const Dropdown = styled.nav`
	position: absolute;
	top: calc(100% + 6px);
	right: -10px;
	background: ${colors.blue.brommaDarkest};
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	li {
		display: block;
		min-width: 150px;
	}

	a {
		color: #fff !important;
		cursor: pointer;
		display: block;
		padding: 10px;

		&:hover,
		&:focus {
			background: rgba(255, 255, 255, 0.1);
			color: #fff !important;
		}
	}
`;

class ProfileDropdown extends React.Component {
	render() {
		const { user, visible, click, logout } = this.props;

		if (!visible) return null;

		return (
			<Dropdown>
				<ul>
					<li>
						<Link to={`/users/edit/${user.id}`} onClick={() => click()}>
							My profile
						</Link>
					</li>

					<li>
						<a onClick={() => logout()}>Logout</a>
					</li>
				</ul>
			</Dropdown>
		);
	}
}

export default ProfileDropdown;



// WEBPACK FOOTER //
// ./src/components/TopBar/ProfileDropdown.js